import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { Display, IsAllowed, NavIconContainer, PageTitle, QuerySingle, Section } from 'gossamer-front-end';
import { Attendance } from 'cb-model';
import { AttendanceDeleteButton } from './AttendanceDeleteButton';

export const AttendanceDisplay = (): React.JSX.Element => {
  const params = useParams();
  return (
    <>
      <NavIconContainer entityId={Attendance.id} />
      <PageTitle title="Record of a User's attendance at an Event" />
      <Section>
        <QuerySingle entity={Attendance} keyValue={params.key} render={Display} />
        <IsAllowed entity={Attendance} action="update">
          <Link to={`/admin/attendance/update/${params.key}`}>
            <Button size="sm" variant="primary">
              Update
            </Button>
          </Link>
        </IsAllowed>
        &nbsp;
        <IsAllowed entity={Attendance} action="delete">
          <AttendanceDeleteButton attendance_id={params.key} />
        </IsAllowed>
      </Section>
    </>
  );
};
